import React, { JSX } from "react";

type RichTextNode = {
  type: string;
  level?: number;
  children?: RichTextNode[];
  text?: string;
  format?: "ordered" | "unordered"; // если Strapi использует это поле для различия списков
};

interface Props {
  content: RichTextNode[];
}

const RichTextRenderer: React.FC<Props> = ({ content }) => {
  const renderNode = (node: RichTextNode, index: number): JSX.Element | null => {
    const { type, children, text, level, format } = node;

    const renderChildren = () =>
      children?.map((child, i) => renderNode(child, i)) ?? null;

    switch (type) {
      case "text":
        return <span key={index}>{text}</span>;

      case "paragraph":
        return <p key={index} className="mb-4">{renderChildren()}</p>;

      case "heading":
        const HeadingTag = `h${level ?? 2}` as keyof JSX.IntrinsicElements;
        return (
          <HeadingTag key={index} className="text-xl font-bold mt-6 mb-2">
            {renderChildren()}
          </HeadingTag>
        );

      case "list":
        if (format === "ordered") {
          return <ol key={index} className="list-decimal pl-6 mb-4">{renderChildren()}</ol>;
        }
        return <ul key={index} className="list-disc pl-6 mb-4">{renderChildren()}</ul>;

      case "list-item":
        return <li key={index}>{renderChildren()}</li>;

      case "quote":
        return (
          <blockquote key={index} className="border-l-4 pl-4 italic my-4 text-gray-600">
            {renderChildren()}
          </blockquote>
        );

      default:
        return <div key={index}>{renderChildren()}</div>;
    }
  };

  return <>{content.map((node, i) => renderNode(node, i))}</>;
};

export default RichTextRenderer;
